import React from "react";
import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Field } from "formik";
import PropTypes from "prop-types";
import FormikLabel from "@/components/forms/FormikLabel";

const RadioFieldComponent = ({ field, errors, touched }) => {
  const hasError = Boolean(touched[field.fieldId] && errors[field.fieldId]);

  return (
    <FormControl
      component="fieldset"
      fullWidth
      error={hasError}
      margin="normal"
    >
      <FormikLabel
        htmlFor={field.fieldId}
        required={field.required}
        disabled={field.disabled}
      >
        {field.fieldName}
      </FormikLabel>
      <Field name={field.fieldId}>
        {({ field: formikField }) => (
          <RadioGroup
            {...formikField}
            id={field.fieldId}
            row // To display options inline, remove this if you want them stacked.
          >
            {field.optionsReference?.options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.name}
                disabled={field.disabled}
              />
            ))}
          </RadioGroup>
        )}
      </Field>
      {hasError && <FormHelperText>{errors[field.fieldId]}</FormHelperText>}
    </FormControl>
  );
};

RadioFieldComponent.propTypes = {
  field: PropTypes.shape({
    fieldId: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    optionsReference: PropTypes.shape({
      options: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          value: PropTypes.string.isRequired,
        })
      ),
    }),
  }).isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
};

export default RadioFieldComponent;
